import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import rootReducer from './reducers/rootReducer';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// import { I18nextProvider } from 'react-i18next';
// import i18n from './i18n';
import config from './config';
const store = createStore(rootReducer)
const CHUNK_RELOAD_KEY = 'tgone-chunk-reload-attempted';

function handleChunkLoadFailure(eventOrMessage) {
      const message = typeof eventOrMessage === 'string'
            ? eventOrMessage
            : eventOrMessage?.reason?.message || eventOrMessage?.message || '';
      if (!/ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/i.test(message)) {
            return;
      }
      if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1') {
            return;
      }
      sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
      window.location.reload();
}

window.addEventListener('error', (event) => {
      handleChunkLoadFailure(event?.error || event?.message);
});

window.addEventListener('unhandledrejection', (event) => {
      handleChunkLoadFailure(event?.reason);
});

window.addEventListener('load', () => {
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

ReactDOM.render(
      <React.StrictMode>
            <React.Suspense fallback={<div>...Loading</div>}>
                  <Provider store={store}>
                        {/* <I18nextProvider i18n={i18n}> */}
                              <Router>
                                    <App />
                              </Router>
                        {/* </I18nextProvider> */}
                  </Provider>
            </React.Suspense>
      </React.StrictMode>,

      document.getElementById('root')
)

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
